import { Box, Button, makeStyles, Typography } from "@material-ui/core";
import LineQR from "./img/LINE_QR.jpg";
import LineApp from "./img/LINE_APP.png";

const useStyles = makeStyles((theme) => ({
  box: {
    width: "100%",
    height: "auto",
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: "5px",
    padding: "0 25px",
    paddingTop: "23px",
    marginBottom: "40px",
    paddingBottom: "33px",
    [theme.breakpoints.between("sm", "sm")]: {
      marginTop: "-20px",
    },
    [theme.breakpoints.down("s")]: {
      marginTop: "-20px",
      padding: "0 10px",
      paddingTop: "15px",
      paddingBottom: "25px",
    },
  },
  inside: {
    width: "100%",
    height: "100%",
    position: "relative",
  },
  paper: {
    width: "100%",
    height: "215px",
    borderRadius: "5px",
    border: "1px solid rgb(232,232,232)",
    boxShadow: "2px 2px 10px 0 rgba(0,0,0, 0.2)",
    maxHeight: "315px",
    backgroundColor: "white",
    display: "flex",
    flexDirection: "row",
    padding: "15px",
    [theme.breakpoints.between("md", "md")]: {
      height: "180px",
    },
    [theme.breakpoints.down("s")]: {
      height: "230px",
    },
  },
  title: {
    marginBottom: "20px",
    [theme.breakpoints.between("md", "md")]: {
      marginBottom: "10px",
    },
    [theme.breakpoints.down("s")]: {
      fontSize: "20px",
    },
  },

  textTitle: {
    marginBottom: "10px",
    [theme.breakpoints.between("md", "md")]: {
      marginBottom: "5px",
      fontSize: "14px",
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: "5px",
      fontSize: "12px",
    },
  },

  paragraph: {
    color: "white",
    textAlign: "left",
    [theme.breakpoints.between("lm", "lm")]: { fontSize: "12px" },
    [theme.breakpoints.between("md", "md")]: { fontSize: "10px" },
    [theme.breakpoints.down("sm")]: { fontSize: "14px" },
  },

  qr: {
    width: "auto",
    height: "80%",
    borderRadius: "5px",
    [theme.breakpoints.between("sm", "sm")]: { width: "45%", height: "auto" },
    [theme.breakpoints.between("s", "s")]: { width: "55%", height: "auto" },
    [theme.breakpoints.between("xs", "xs")]: { width: "75%", height: "auto" },
  },
  line_img: {
    width: "auto",
    height: "100%",
    margin: "auto",

    [theme.breakpoints.between("sm", "sm")]: { width: "90%", height: "auto" },
    [theme.breakpoints.between("s", "s")]: { width: "90%", height: "auto" },
    [theme.breakpoints.between("xs", "xs")]: { width: "85%", height: "auto" },
  },

  line_box: {
    width: "100%",
    height: "100%",
    backgroundColor: "#00b900",
    display: "flex",
    padding: "10px",
    borderRadius: "5px",
  },
  column: {
    display: "flex",
    flex: "50%",
    justifyContent: "center",
    alignItems: "center",
    padding: "5px",
  },
  leftColumn: {
    display: "flex",
    flex: "50%",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  lineInfo: {
    color: "white",
    letterSpacing: "2px",
  },
  button: {
    borderRadius: "25px",
    padding: "5px 24px",
    marginLeft: "-5px",
    width: "125px",
    [theme.breakpoints.between("s", "s")]: { fontSize: "12px" },
    [theme.breakpoints.between("xs", "s")]: {
      fontSize: "10px",
      width: "115px",
    },
  },
  textBody: {
    display: "flex",
    flex: " 1 0 ",
    height: "100%",
    flexDirection: "column",
    justifyContent: "center",
    width: "auto",
    padding: "5px",
  },
  imgLine: {
    display: "flex",
    flex: " 1 0 ",
    height: "100%",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  line: {
    width: "100%",
    height: "auto",
    maxWidth: "100px",
    maxHeight: "100px",

    flex: "1 0 ",
    [theme.breakpoints.between("xs", "s")]: { display: "none" },
  },
  smallLine: {
    width: "25px",
    height: "auto",
    [theme.breakpoints.up("sm")]: { display: "none" },
  },
}));
export default function NewsInfoBox() {
  const classes = useStyles();
  return (
    <Box className={classes.box}>
      <Box className={classes.inside}>
        <Typography className={classes.title} variant="h2">
          SNS新着情報
        </Typography>
        <Box className={classes.paper}>
          <Box className={classes.line_box}>
            <LeftCol />
            <QR />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

const QR = () => {
  const classes = useStyles();
  return (
    <Box className={classes.column}>
      <img src={LineQR} alt="qr line" className={classes.qr} />
    </Box>
  );
};
const LeftCol = () => {
  const classes = useStyles();
  return (
    <Box className={classes.leftColumn}>
      <Box className={classes.imgLine}>
        <img src={LineApp} alt="img" className={classes.line} />
      </Box>
      <Box className={classes.textBody}>
        <Typography variant="h3" gutterBottom className={classes.lineInfo}>
          LINE <img src={LineApp} alt="img" className={classes.smallLine} />
        </Typography>

        <Typography className={classes.paragraph} gutterBottom variant="body1">
          公式アカウント
        </Typography>

        <Typography className={classes.paragraph} gutterBottom variant="body1">
          始めました
        </Typography>
        <Button className={classes.button} variant="contained" color="primary">
          友だち追加
        </Button>
      </Box>
    </Box>
  );
};
